import { useState } from "react";
import PageHero from "../components/sections/PageHero";
import CTABlock from "../components/sections/CTABlock";
import { insights } from "../data/insights";
import { ArrowUpRight } from "lucide-react";

const categories = [
  "All",
  "Litigation",
  "Real Estate & RERA",
  "Corporate Advisory",
  "Contracts & Documentation",
  "Legal Strategy",
  "Regulatory Updates",
];

export default function InsightsPage() {
  const [active, setActive] = useState("All");
  const filtered =
    active === "All" ? insights : insights.filter((i) => i.category === active);

  return (
    <>
      <PageHero
        eyebrow="Perspectives"
        title="Insights"
        subtitle="Legal perspectives, practical explainers and updates from Lex Polaris across litigation, corporate advisory, real estate, RERA and dispute resolution."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Insights" }]}
      />

      {/* CATEGORIES */}
      <section className="bg-ivory border-b border-soft-grey" data-testid="insights-categories">
        <div className="container-px max-w-[1400px] mx-auto py-7 flex flex-wrap gap-x-3 gap-y-2">
          {categories.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setActive(c)}
              data-testid={`insights-cat-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={`text-[11px] tracking-[0.22em] uppercase px-4 py-2 border transition-colors ${
                active === c
                  ? "bg-navy text-ivory border-navy"
                  : "bg-transparent text-charcoal/70 border-soft-grey hover:border-navy hover:text-navy"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </section>

      {/* GRID */}
      <section className="bg-white section-y" data-testid="insights-grid">
        <div className="container-px max-w-[1400px] mx-auto">
          {filtered.length === 0 ? (
            <p className="text-charcoal/60 py-20 text-center">No insights in this category yet.</p>
          ) : (
            <div className="grid md:grid-cols-2 gap-x-12 gap-y-16 lg:gap-y-24">
              {filtered.map((post, i) => (
                <article
                  key={post.slug}
                  id={post.slug}
                  data-testid={`insight-card-${post.slug}`}
                  className={`group ${i % 2 === 1 ? "md:mt-16" : ""}`}
                >
                  <div className="aspect-[5/4] overflow-hidden bg-soft-grey mb-7">
                    <img
                      src={post.image}
                      alt={post.imageAlt || post.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      loading="lazy"
                    />
                  </div>
                  <div className="overline text-gold mb-4">{post.category}</div>
                  <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl text-navy leading-tight mb-5 group-hover:text-gold transition-colors">
                    {post.title}
                  </h2>
                  <p className="body-lg text-charcoal/75 mb-6">{post.summary}</p>
                  <div className="space-y-4">
                    {post.body.map((p, idx) => (
                      <p key={idx} className="text-charcoal/75 text-[15px] leading-relaxed">
                        {p}
                      </p>
                    ))}
                  </div>
                  <div className="mt-7">
                    <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-navy border-b border-navy/40 pb-1">
                      Lex Polaris Editorial <ArrowUpRight size={14} />
                    </span>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      <CTABlock />
    </>
  );
}
